import {gql} from '@apollo/client';

import {getApolloClient} from 'graphql-client/ApolloClient';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import ExtractByTypename from 'graphql-client/ExtractByTypename';

import {RequestV2SubmissionGraphQL} from '../../../../graphql-fragments/processes/requests-v2/__generated/RequestV2SubmissionGraphQL';
import {RequestV2SubmissionDetailsQuery} from './__generated/RequestV2SubmissionDetailsQuery';

export type RequestV2SubmissionDetails = ExtractByTypename<
  RequestV2SubmissionDetailsQuery['requestV2Submission'],
  'RequestV2SubmissionNode'
>;

export const REQUEST_V2_SUBMISSION_DETAILS_QUERY = gql`
  query RequestV2SubmissionDetailsQuery($requestV2SubmissionId: StrictString!)
  @skipAudit
  @engComponent(name: WORKFLOWS) {
    requestV2Submission(id: $requestV2SubmissionId) {
      ...RequestV2SubmissionGraphQL
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('RequestV2Submission').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

/**
 * Transforms a request v2 submission that is returned from the API to a request v2 submission that is used by the details page.
 *
 * This is useful layer of abstraction because the API response could contain additional information about the submission that is not
 * relevant for the details page and could result in us writing extraneous data to the Apollo cache.
 *
 * @param requestV2SubmissionFromApi A request v2 submission that is returned from the API
 * @returns The request v2 submmission that is used by the details page
 */
export function getRequestV2SubmissionDetailsFromApiResponse(
  requestV2SubmissionFromApi: RequestV2SubmissionGraphQL
): RequestV2SubmissionDetails {
  return requestV2SubmissionFromApi;
}

export function writeRequestV2SubmissionUpdateToCache(requestV2Submission: RequestV2SubmissionDetails): void {
  getApolloClient().writeQuery({
    query: REQUEST_V2_SUBMISSION_DETAILS_QUERY,
    data: {
      requestV2Submission,
    },
    variables: {
      requestV2SubmissionId: requestV2Submission.id,
    },
  });
}
